export function reconcileEvaluationStoreIds(
  selectedStoreIds,
  stores,
  homeStoreId
) {
  const storeIdsByKey = new Map(
    (stores || [])
      .filter((store) => store?.id !== undefined && store?.id !== null)
      .map((store) => [String(store.id), store.id])
  );
  const seen = new Set();
  const validSelectedStoreIds = (selectedStoreIds || []).reduce(
    (selection, storeId) => {
      const key = String(storeId);
      if (storeIdsByKey.has(key) && !seen.has(key)) {
        selection.push(storeIdsByKey.get(key));
        seen.add(key);
      }
      return selection;
    },
    []
  );

  if (validSelectedStoreIds.length) {
    return validSelectedStoreIds;
  }

  const homeStoreKey = String(homeStoreId);
  if (storeIdsByKey.has(homeStoreKey)) {
    return [storeIdsByKey.get(homeStoreKey)];
  }

  const firstStoreId = (stores || [])[0]?.id;
  return firstStoreId === undefined || firstStoreId === null
    ? []
    : [firstStoreId];
}
